module.exports = __webpack_public_path__ + "img/planwave-2.399bb7e4.png";